module.exports = __webpack_public_path__ + "static/main5_pc-f8d5891f77534ab87380091f4551ce13.jpg";